<template>
    <footer v-if="this.$route.name !== 'Chat'"
        style="min-height: 80px; padding-left: 100px;"
        class="pt-4 mt-1 border-top">
        <!--    <hr>-->
        <div class="row px-4 pt-3 justify-content-between">
            <div>
                <small>
                    <strong class="title-color" style="font-family: 'Product Sans Bold'; text-transform: uppercase;">
                      {{ configs.data.partner.name }}
                    </strong>
                    © 2018-{{ year }}
                </small>
            </div>
            <div>
                <small>v {{ configs.data.version }}</small>
            </div>
        </div>
    </footer>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Footer",
    computed: {
        ...mapState(['configs']),
    },
    data() {
        return {
            year: new Date().getFullYear(),
        }
    },
}
</script>

<style scoped>

</style>
